import { render, staticRenderFns } from "./specifyOnput.vue?vue&type=template&id=d5404944&scoped=true&"
import script from "./specifyOnput.vue?vue&type=script&lang=js&"
export * from "./specifyOnput.vue?vue&type=script&lang=js&"
import style0 from "./specifyOnput.vue?vue&type=style&index=0&id=d5404944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5404944",
  null
  
)

export default component.exports